import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { GetJson, PutJson, PostJson, DeleteJson } from '@awp/helpers/fetchReact';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { isValueEmpty, isObjectEmpty, isJsonValueEmpty, isValidRelElevation } from '@awp/helpers/utilsReact';
import { setHours, setMinutes, subDays, addMilliseconds, format as formatDate } from 'date-fns';
import { SENSOR_PLACEMENT_CONFIG, FROST_PROBE_CONFIG, SNOW_POLE_CONFIG, STATE_STATUS, REST_API } from '@awp/constants';
import {
  setEditing,
  setSegment,
  setOrignSegment,
  setSaveSegmentStatus,
  setSaveSegmentError,
  setData,
  getWeatherStationId,
  getCurrentSensorEquipmentPacket,
  getSelectedSegment,
  getOrignSegment,
  getSaveSegmentStatus,
  getSaveSegmentError,
  getOperationStartDate,
  getObservationTypes,
  getPlacementTemplates,
} from '@stores/sensorEquipmentPacketSlice';
import _ from 'lodash';
import { Crud, CrudCreate } from '@awp/shared/Crud';

const CreateSegmentModal = ({ placement, visible, closeModal }) => {
  const dispatch = useDispatch();
  //const segmentTemplateList = useSelector(getSegmentTemplate);//TO-DO
  const weatherStationId = useSelector(getWeatherStationId);
  const currentSensorEquipmentPacket = useSelector(getCurrentSensorEquipmentPacket);
  const observationTypeList = useSelector(getObservationTypes);
  const selectedSegment = useSelector(getSelectedSegment);
  const selectedOrignSegment = useSelector(getOrignSegment);
  const saveSegmentError = useSelector(getSaveSegmentError);
  const operationStartDate = useSelector(getOperationStartDate);
  const [show, setShow] = useState(visible);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [placementTemplateList, setPlacementTemplateList] = useState([]);
  const [templateLoading, setTemplateLoading] = useState(false);
  const [offsetError, setOffsetError] = useState('');
  const [offset, setOffset] = useState('');

  const crud = new CrudCreate('Segment');
  const { buttonLabel } = crud;

  const handleClose = useCallback(() => {
    if (!isObjectEmpty(selectedSegment)) removeEmptySegment(); //TO-DO template
    cleanData();
    closeModal();
  }, [currentSensorEquipmentPacket, selectedSegment]);
  useEffect(() => {
    if (show && placement) {
      setTemplateLoading(true);
      const url = REST_API.PLACEMENT_TEMPLATES + 'placementTemplatePacket/' + placement.SensorTypeId;
      GetJson(url)
        .then((response) => response.json())
        .then((data) => {
          let _allTemplateOptions = [];
          if (data && data.PlacementTemplates && data.PlacementTemplates.length > 0) {
            setPlacementTemplateList(data.PlacementTemplates);
            data.PlacementTemplates.map((t) => {
              if (t.SensorTypeId === placement.SensorTypeId) {
                _allTemplateOptions.push({ value: t.Id, label: t.Name });
              }
            });
          }
          setTemplateOptions(_allTemplateOptions);
          setTemplateLoading(false);
        });
    }
  }, [show, placement]);
  useEffect(() => {
    setShow(visible);
  }, [visible]);

  const removeEmptySegment = () => {
    let _data = { ...currentSensorEquipmentPacket };
    let _sensorEquipmentSets = [..._data.SensorEquipmentSets];
    let _newSensorEquipmentSets = [];
    _sensorEquipmentSets.map((sp) => {
      let _sp = { ...sp };
      let _newPlacementSegments = [];
      sp.PlacementSegments.map((seg) => {
        if (seg.Id !== SENSOR_PLACEMENT_CONFIG.SEG_ID) _newPlacementSegments.push(seg);
      });
      _sp.PlacementSegments = _newPlacementSegments;
      _newSensorEquipmentSets.push(_sp.PlacementSegments);
    });

    _data.SensorEquipmentSets = _newSensorEquipmentSets;
    dispatch(setData(_data));
  };
  const createNewEmptySots = () => {
    if (
      selectedTemplate &&
      selectedTemplate.TemplateObservationTypes &&
      selectedTemplate.TemplateObservationTypes.length > 0
    ) {
      return createNewSotsByTemplate();
    }
    let newSot = { ...SENSOR_PLACEMENT_CONFIG.NEW_SEGMENT_OBSERVATION_TYPE };
    let sotId = SENSOR_PLACEMENT_CONFIG.SOT_ID - 1;
    newSot.Id = sotId;
    newSot.PlacementSegmentId = SENSOR_PLACEMENT_CONFIG.SEG_ID;
    let newSots = [];
    newSots.push(newSot);
    return newSots;
  };
  const createNewFrostProbeSots = () => {
    let newSots = [];
    let _selectedTemplate = { ...selectedTemplate };
    if (
      _selectedTemplate &&
      _selectedTemplate.TemplateObservationTypes &&
      _selectedTemplate.TemplateObservationTypes.length > 0
    ) {
      let idx = FROST_PROBE_CONFIG.SOT_ID - 1;
      let i = 1;
      let relElevation = null;
      _selectedTemplate.TemplateObservationTypes.forEach((tmpl) => {
        let sot = { ...SENSOR_PLACEMENT_CONFIG.NEW_SEGMENT_OBSERVATION_TYPE };
        if (tmpl.ObservationTypeName === FROST_PROBE_CONFIG.SUBSFC_TEMP) {
          if (!isValueEmpty(offset) && !isValueEmpty(tmpl.OffsetElevationMillimetres)) {
            relElevation = _.round(_.toNumber(offset) + _.toNumber(tmpl.OffsetElevationMillimetres), 1); // 1 digit allowed
          } else if (isValueEmpty(offset) && !isValueEmpty(tmpl.OffsetElevationMillimetres)) {
            relElevation = tmpl.OffsetElevationMillimetres;
          }
        }
        sot.Id = idx;
        sot.ObservationTypeId = tmpl.ObservationTypeId;
        sot.ObservationTypeName = tmpl.ObservationTypeName;
        sot.ObservationTypeDisplayName = tmpl.ObservationTypeDisplayName;
        sot.DisplayName = tmpl.DisplayName;
        sot.SensorLayerNumber = tmpl.ObservationTypeName === FROST_PROBE_CONFIG.SUBSFC_TEMP ? i : null;
        sot.RelativeElevationMillimetres =
          tmpl.ObservationTypeName === FROST_PROBE_CONFIG.SUBSFC_TEMP && !isValueEmpty(tmpl.OffsetElevationMillimetres)
            ? relElevation
            : null;
        sot.PlacementSegmentId = SENSOR_PLACEMENT_CONFIG.SEG_ID;
        newSots.push(sot);
        idx++;
        if (tmpl.ObservationTypeName == FROST_PROBE_CONFIG.SUBSFC_TEMP) i++;
      });
    } else {
      const otSurf = observationTypeList.find((opt) => opt.label == FROST_PROBE_CONFIG.SUBSFC_TEMP);
      const otPreRest = observationTypeList.find((opt) => opt.label == FROST_PROBE_CONFIG.PRECISN_RESISTOR);

      let idx = FROST_PROBE_CONFIG.SOT_ID - 1;
      let sotPrecisnResistor = { ...SENSOR_PLACEMENT_CONFIG.NEW_SEGMENT_OBSERVATION_TYPE };
      sotPrecisnResistor.Id = idx;
      sotPrecisnResistor.ObservationTypeId = otPreRest.value;
      sotPrecisnResistor.ObservationTypeName = otPreRest.label;
      sotPrecisnResistor.ObservationTypeDisplayName = otPreRest.observationTypeDisplayName;
      sotPrecisnResistor.PlacementSegmentId = SENSOR_PLACEMENT_CONFIG.SEG_ID;
      newSots.push(sotPrecisnResistor);

      let maxCnt = FROST_PROBE_CONFIG.DEFAULT_SOT_COUNT + 1;
      idx = FROST_PROBE_CONFIG.SOT_ID - maxCnt;
      for (let i = 1; i < maxCnt; i++) {
        let sot = { ...SENSOR_PLACEMENT_CONFIG.NEW_SEGMENT_OBSERVATION_TYPE };
        sot.Id = idx;
        sot.ObservationTypeId = otSurf.value;
        sot.ObservationTypeName = otSurf.label;
        sot.ObservationTypeDisplayName = otSurf.observationTypeDisplayName;
        sot.SensorLayerNumber = i;
        sot.PlacementSegmentId = SENSOR_PLACEMENT_CONFIG.SEG_ID;
        newSots.push(sot);
        idx++;
      }
    }
    return newSots;
  };

  const createNewSnowPoleSots = () => {
    let newSots = [];
    let _selectedTemplate = { ...selectedTemplate };
    if (
      _selectedTemplate &&
      _selectedTemplate.TemplateObservationTypes &&
      _selectedTemplate.TemplateObservationTypes.length > 0
    ) {
      let maxCnt = SNOW_POLE_CONFIG.DEFAULT_SOT_COUNT + 1;
      let idx = SNOW_POLE_CONFIG.SOT_ID - maxCnt;
      let i = 1;
      let relElevation = null;
      _selectedTemplate.TemplateObservationTypes.forEach((tmpl) => {
        let sot = { ...SENSOR_PLACEMENT_CONFIG.NEW_SEGMENT_OBSERVATION_TYPE };
        if (tmpl.ObservationTypeName === SNOW_POLE_CONFIG.SNWPK_TEMP) {
          if (!isValueEmpty(offset) && !isValueEmpty(tmpl.OffsetElevationMillimetres)) {
            relElevation = _.toNumber(offset) + _.toNumber(tmpl.OffsetElevationMillimetres);
          } else if (isValueEmpty(offset) && !isValueEmpty(tmpl.OffsetElevationMillimetres)) {
            relElevation = tmpl.OffsetElevationMillimetres;
          }
        }
        sot.Id = idx;
        sot.ObservationTypeId = tmpl.ObservationTypeId;
        sot.ObservationTypeName = tmpl.ObservationTypeName;
        sot.ObservationTypeDisplayName = tmpl.ObservationTypeDisplayName;
        sot.DisplayName = tmpl.DisplayName;
        sot.SensorLayerNumber = tmpl.ObservationTypeName === SNOW_POLE_CONFIG.SNWPK_TEMP ? i : null;
        sot.RelativeElevationMillimetres =
          tmpl.ObservationTypeName === SNOW_POLE_CONFIG.SNWPK_TEMP && !isValueEmpty(tmpl.OffsetElevationMillimetres)
            ? relElevation
            : null;
        sot.PlacementSegmentId = SENSOR_PLACEMENT_CONFIG.SEG_ID;
        newSots.push(sot);
        idx++;
        if (tmpl.ObservationTypeName == SNOW_POLE_CONFIG.SNWPK_TEMP) i++;
      });
    } else {
      const otSnwPk = observationTypeList.find((opt) => opt.label == SNOW_POLE_CONFIG.SNWPK_TEMP);
      let maxCnt = SNOW_POLE_CONFIG.DEFAULT_SOT_COUNT + 1;
      let idx = SNOW_POLE_CONFIG.SOT_ID - maxCnt;
      for (let i = 1; i < maxCnt; i++) {
        let sot = { ...SENSOR_PLACEMENT_CONFIG.NEW_SEGMENT_OBSERVATION_TYPE };
        sot.Id = idx;
        sot.ObservationTypeId = otSnwPk.value;
        sot.ObservationTypeName = otSnwPk.label;
        sot.ObservationTypeDisplayName = otSnwPk.observationTypeDisplayName;
        sot.SensorLayerNumber = i;
        sot.PlacementSegmentId = SENSOR_PLACEMENT_CONFIG.SEG_ID;
        newSots.push(sot);
        idx++;
      }
    }
    return newSots;
  };

  const createNewSots = () => {
    if (!SENSOR_PLACEMENT_CONFIG.MAPPINGS.includes(placement.SensorTypeName)) return createNewEmptySots();
    if (placement.SensorTypeName === FROST_PROBE_CONFIG.FORST_PROBE_SENSOR_TYPE) return createNewFrostProbeSots();
    if (placement.SensorTypeName === SNOW_POLE_CONFIG.SNOW_POLE_SENSOR_TYPE) return createNewSnowPoleSots();
    return createNewEmptySots();
  };
  const createNewSotsByTemplate = () => {
    let _selectedTemplate = { ...selectedTemplate };
    let _tots = [..._selectedTemplate.TemplateObservationTypes];
    let newSots = [];
    let i = 1;
    _tots.forEach((tot) => {
      let newSot = { ...SENSOR_PLACEMENT_CONFIG.NEW_SEGMENT_OBSERVATION_TYPE };
      let sotId = SENSOR_PLACEMENT_CONFIG.SOT_ID - i;
      newSot.Id = sotId;
      newSot.PlacementSegmentId = SENSOR_PLACEMENT_CONFIG.SEG_ID;
      (newSot.ObservationTypeId = tot.ObservationTypeId),
        (newSot.ObservationTypeName = tot.ObservationTypeName),
        (newSot.ObservationTypeDisplayName = tot.ObservationTypeDisplayName),
        (newSot.DisplayName = tot.DisplayName),
        newSots.push(newSot);
      i++;
    });
    return newSots;
  };
  const addEmptySegment = (isAddStartTime) => {
    let startTs = isValueEmpty(operationStartDate) ? '' : formatDate(new Date(operationStartDate), 'yyyy-MM-dd HH:mm');

    let newSots = createNewSots();
    let newSegment = {
      Id: SENSOR_PLACEMENT_CONFIG.SEG_ID,
      SensorPlacementId: placement.SensorPlacementId,
      SensorTypeId: placement.SensorTypeId,
      SensorTypeName: placement.SensorTypeName,
      SegmentEffectiveTimestamp: isAddStartTime ? startTs : '',
      SourceName: '',
      SensorLayerNumber: null,
      CollectionIntervalMinutes: 60,
      SensorId: null,
      RelativeElevationMillimetres: null,
      WeatherStationId: weatherStationId,
      IsSegCollapsed: 2,
      SegmentObservationTypes: newSots,
    };
    dispatch(setSegment(newSegment));
    dispatch(setEditing(SENSOR_PLACEMENT_CONFIG.SEGMENT_TAG + newSegment.Id));
    return newSegment;
  };
  const cleanProbeHeight = () => {
    setOffset('');
    setOffsetError('');
  };
  const cleanTemplateData = () => {
    cleanProbeHeight();
    setSelectedTemplate(null);
  };
  const cleanData = () => {
    cleanTemplateData();
    dispatch(setEditing(null));
    dispatch(setOrignSegment(null));
    dispatch(setSegment(null));
    dispatch(setSaveSegmentError(null));
  };

  const updateTemplate = (e) => {
    if (isValueEmpty(e) || isValueEmpty(e.value)) {
      cleanTemplateData();
      return;
    }
    const tmpId = e.value + '';
    const template = placementTemplateList.find((opt) => opt.Id == tmpId);
    if (!isJsonValueEmpty(template) && template.TemplateObservationTypes.length > 0) {
      setSelectedTemplate(template);
    } else {
      cleanTemplateData();
    }

    //addEmptySegment();
  };
  const handleSegmentSubmit = () => {
    let _data = { ...currentSensorEquipmentPacket };
    let _sensorEquipmentSets = _data.SensorEquipmentSets;

    let isAddStartTime = false;
    _sensorEquipmentSets.map((sp) => {
      let _sp = { ...sp };
      if (_sp.SensorPlacementId === placement.SensorPlacementId) {
        if (isJsonValueEmpty(_sp.PlacementSegments) || _sp.PlacementSegments.length === 0) isAddStartTime = true;
      }
    });

    let _selectedSegment = { ...selectedSegment };
    if (isObjectEmpty(_selectedSegment)) {
      _selectedSegment = addEmptySegment(isAddStartTime);
    }

    let _newSensorEquipmentSets = [];
    _sensorEquipmentSets.map((sp) => {
      let _sp = { ...sp };
      let _newPlacementSegments = [];

      if (_sp.SensorPlacementId === placement.SensorPlacementId) {
        _newPlacementSegments.push(_selectedSegment);
      }

      if (_sp.PlacementSegments && _sp.PlacementSegments.length > 0) {
        _sp.PlacementSegments.map((seg) => {
          if (seg.Id !== SENSOR_PLACEMENT_CONFIG.SEG_ID) _newPlacementSegments.push(seg);
        });
      }
      _sp.PlacementSegments = _newPlacementSegments;
      _newSensorEquipmentSets.push(_sp);
    });

    _data.SensorEquipmentSets = _newSensorEquipmentSets;
    dispatch(setData(_data));
    cleanTemplateData();
    closeModal();
  };

  const updateOffsetElevationMillimetres = (e) => {
    e.preventDefault();
    setOffsetError('');
    const val = e.target.value;
    if (isValidRelElevation(val)) {
      if (placement.SensorTypeName === FROST_PROBE_CONFIG.FORST_PROBE_SENSOR_TYPE && _.toNumber(val) > 0) {
        setOffsetError('invalid value.');
        return;
      }
      if (placement.SensorTypeName === SNOW_POLE_CONFIG.SNOW_POLE_SENSOR_TYPE && _.toNumber(val) < 0) {
        setOffsetError('invalid value.');
        return;
      }
      setOffset(val);
    } else {
      setOffsetError('invalid value.');
    }
  };
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>{crud.getModalTitle()}</Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={10}>
            <Form.Group>
              <Form.Label>
                <b>Select segment template (optional) </b>
              </Form.Label>
              <br />
              {templateOptions && (
                <Select
                  options={templateOptions}
                  placeholder={'Select ...'}
                  onChange={updateTemplate}
                  isClearable={true}
                />
              )}
              {/* {stError && <Form.Control.Feedback type="invalid"
									className="d-block">{"Sensor type is required."}
							</Form.Control.Feedback>} */}
            </Form.Group>
          </Col>
        </Row>
        {placement && selectedTemplate && SENSOR_PLACEMENT_CONFIG.MAPPINGS.includes(placement.SensorTypeName) && (
          <Row>
            <Col md={10}>
              <Form.Label>
                <b>
                  {'Probe Height '}&#177; {'cm (optional)'}{' '}
                </b>
                <br />
                {'Distance from ground level to top of probe measured in cm '}&#177;
              </Form.Label>
              <br />
              <Form.Control
                id={'offsetPrefixId'}
                style={{ width: '6rem' }}
                onChange={updateOffsetElevationMillimetres}
                //style={ sotInput}
                type="text"
                //value={ isValueEmpty(tot.OffsetElevationMillimetres) ? "" :tot.OffsetElevationMillimetres}
                //placeholder={tot.ObservationTypeDisplayName}
              />
              {!isValueEmpty(offsetError) && (
                <Form.Control.Feedback type="invalid" className="d-block">
                  {offsetError}
                </Form.Control.Feedback>
              )}
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" disabled={!isValueEmpty(offsetError)} onClick={handleSegmentSubmit}>
          {buttonLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

CreateSegmentModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default CreateSegmentModal;
